import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Card } from 'react-bootstrap';

const propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
};

const defaultProps = {
  id: '',
};

const PanelComponent = ({
  children,
  id,
  panelClass,
  panelCollapseClass,
  panelBodyClass,
  isExpanded,
  onToggle,
}) => (
  <Accordion
    id={id}
    activeKey={isExpanded ? '1' : ''}
    onSelect={onToggle}
  >
    <Card className={panelClass}>
      <Accordion.Collapse eventKey="1" className={panelCollapseClass}>
        <Card.Body className={panelBodyClass}>{children}</Card.Body>
      </Accordion.Collapse>
    </Card>
  </Accordion>
);

PanelComponent.propTypes = propTypes;
PanelComponent.defaultProps = defaultProps;

export default PanelComponent;
